var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckMode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCheckMode") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SafeMode-PopUp",
    transform: "translate(-152.000000, -363.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Radio---selected",
    transform: "translate(151.000000, 362.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(1.680000, 1.680000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.64,40.3210752 C80.64,18.1133022 62.5288482,0 40.3210752,0 C18.1133022,0 0,18.1133022 0,40.3210752 C0,62.5288482 18.1133022,80.64 40.3210752,80.64 C62.5288482,80.64 80.64,62.5288482 80.64,40.3210752 Z",
    id: "Fill-3",
    fill: "#7EC34D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFFFFF",
    points: "54.3192525 23.52 34.1592525 43.327728 26.3188916 35.6268 20.16 41.681568 34.1592525 55.44 60.48 29.574768"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckMode);
export default __webpack_public_path__ + "static/media/icCheckMode.017cd29d1a83cbc44589891f3e8a21f5.svg";
export { ForwardRef as ReactComponent };